import { useState, type ReactNode } from 'react';
import { CenteredPage } from '../../components/layout/CenteredPage';

const DISMISS_KEY = 'hp_a_small_screen_ok';

function readDismissed(): boolean {
  try {
    return sessionStorage.getItem(DISMISS_KEY) === '1';
  } catch {
    return false;
  }
}

/**
 * Stands in front of a screen that is not turned on for phones (`NavItem.mobile`)
 * when it is opened on a small screen — from a link, since the drawer lists
 * those screens disabled. The shell decides `blocked`; the screens turned on
 * for phones never see it. "Continue anyway" lets someone through for this tab.
 */
export function ScreenSizeGate({ blocked, children }: { blocked: boolean; children: ReactNode }) {
  const [dismissed, setDismissed] = useState(readDismissed);

  if (!blocked || dismissed) return <>{children}</>;

  const continueAnyway = () => {
    try {
      sessionStorage.setItem(DISMISS_KEY, '1');
    } catch {
      /* storage unavailable — it just won't be remembered */
    }
    setDismissed(true);
  };

  return (
    <CenteredPage
      as="div"
      title="Houston, we have a small screen."
      actions={
        <button
          type="button"
          onClick={continueAnyway}
          className="mt-6 cursor-pointer self-center border-0 bg-transparent p-0 font-body text-xs text-muted underline underline-offset-2 hover:text-ink"
        >
          Continue anyway
        </button>
      }
    >
      This screen is flown from a desktop or tablet. Grab one and we&apos;re go for launch.
    </CenteredPage>
  );
}
